/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetBuyerInfoRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetBuyerInfoResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getBuyerInfo = (request: GetBuyerInfoRequest, options?: CashRequestOptions) => post<GetBuyerInfoRequest, GetBuyerInfoResponse>("/cash-app/local/profile/buyer", request, {...options, rejectOnError: true })